import apiSchedule from '@/api/supplier/schedules';
import apiOption from '@/api/supplier/option';

const defaultState = () => ({
	scheduleResults: [],
	detailSchedule: '',
	schedulePagination: '',
	optionWarehouse: [],
	optionProduct: [],
	responSukses: '',
	alert: '',
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {
	listschedule(state, data) {
		state.scheduleResults = data.data;
		state.schedulePagination = data.pagination;
	},
	setDetailSchedule(state, data) {
		state.detailSchedule = data
	},
	listOptionWarehouse(state, data) {
		state.optionWarehouse = data
	},
	listOptionProduct(state, data) {
		state.optionProduct = data
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataschedule(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getSchedules({ commit }, value) {
		return new Promise((resolve) => {
			apiSchedule.getSchedules(value).then(({ data: { data } }) => {
				commit('listschedule', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('listschedule', { data: [], pagination: {} });
			});
		});
	},
	getDetailSchedule({ commit, dispatch }, params) {
		apiSchedule.getDetailSchedule(params).then(({ data: { data } }) => {
			commit('setDetailSchedule', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailSchedule', { data: [] });
		});
	},
	getOptionWarehouse({ commit }, value) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouse(value).then(({ data: { data } }) => {
				commit('listOptionWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('listOptionWarehouse', []);
			});
		});
	},
	getOptionProduct({ commit }, value) {
		return new Promise((resolve) => {
			apiOption.getOptionProduct(value).then(({ data: { data } }) => {
				commit('listOptionProduct', data.results);
				resolve()
			}).catch(() => {
				commit('listOptionProduct', []);
			});
		});
	},
	async exportSchedules({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSchedule.exportSchedules(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Jadwal Pnegiriman'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};